var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewWriteIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1.297 3.233A.75.75 0 1 0 .203 4.259L3.205 7.46a.75.75 0 0 0 1.086.009l5.998-6.198A.75.75 0 1 0 9.211.228l-5.45 5.633-2.464-2.628z"
  })));
}
export default SvgReviewWriteIconCheck;